import { render, staticRenderFns } from "./BalanceDepositTransaction.vue?vue&type=template&id=2485f80b&scoped=true&"
import script from "./BalanceDepositTransaction.vue?vue&type=script&lang=js&"
export * from "./BalanceDepositTransaction.vue?vue&type=script&lang=js&"
import style0 from "./BalanceDepositTransaction.vue?vue&type=style&index=0&id=2485f80b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2485f80b",
  null
  
)

export default component.exports